import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { connect } from "react-redux";

import { Alert } from "reactstrap";

import {
  Typography,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Toolbar,
  Chip,
  TextField,
  Tooltip,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import accessToken from "../../../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import {
  getOrgAccounts,
  clearAllOrgAcctMessages,
} from "../../../store/orgAcct/actions";

import {
  getOrganizationIaac,
  getOrganizationIaacLicenses,
  postOrganizationIaac,
  putOrganizationIaac,
  clearAllOrganizationIaacMessages,
  getGlobalIaac,
  clearAllGlobalIaacMessages,
  deleteOrganizationIaac,
} from "../../../store/actions";

import { orderSubscriptions } from "../../../GlobalLicenseManagement/GlobalIaaC";

import spinner from "../../../assets/images/loadingGif.gif";

const STANDARD_IAAC_PLANS = [
  "Basic",
  "Standard",
  "Premium",
  "Enterprise",
  "AWS Marketplace",
];

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const OrganizationIaac = (props) => {
  console.log("OrganizationIaac props: ", props);
  const getOrganizationIaac = useCallback(props.getOrganizationIaac, []);
  const getOrganizationIaacLicenses = useCallback(
    props.getOrganizationIaacLicenses,
    []
  );
  const getGlobalIaac = useCallback(props.getGlobalIaac, []);
  const clearAllOrganizationIaacMessages = useCallback(
    props.clearAllOrganizationIaacMessages,
    []
  );
  const clearAllGlobalIaacMessages = useCallback(
    props.clearAllGlobalIaacMessages,
    []
  );
  const clearAllOrgAcctMessages = useCallback(
    props.clearAllOrgAcctMessages,
    []
  );
  const getOrgAccounts = useCallback(props.getOrgAccounts, []);

  const [customLicenseName, setCustomLicenseName] = useState("");
  const [customPrice, setCustomPrice] = useState("");
  const [customLimit, setCustomLimit] = useState("");

  const [editCustomLicenseName, setEditCustomLicenseName] = useState("");
  const [editCustomPrice, setEditCustomPrice] = useState("");
  const [editCustomLimit, setEditCustomLimit] = useState("");
  const [customSubscription, setCustomSubscription] = useState(null);

  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [activeTab, setActiveTab] = useState("plans");

  const { orgCode } = useParams();
  const appBarStyles = {
    backgroundColor: "whitesmoke",
    // Add more custom styles as needed
  };
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const classes = useStyles();

  useEffect(() => {
    if (props.organization === null) {
      getOrgAccounts(orgCode);
    }
  }, [getOrgAccounts, props.organization, orgCode]);

  //For displaying message for getting organization account
  let getOrgAccountsMsg = props.getOrgAccountsMessage;
  let getOrgAccountsErr = props.getOrgAccountsError;
  useEffect(() => {
    console.log("getOrgAccountsMsg = " + getOrgAccountsMsg);
    if (getOrgAccountsMsg || getOrgAccountsErr) {
      console.log("Inside if, getOrgAccountsMsg = " + getOrgAccountsMsg);
      setTimeout(() => {
        clearAllOrgAcctMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getOrgAccountsMsg, getOrgAccountsErr, clearAllOrgAcctMessages]);

  // Get organization iaac information
  useEffect(() => {
    console.log("~~~~~useEffect for getting iaac information");
    if (props.iaac === null) {
      console.log("~~~~~props.iaac===null");
      getOrganizationIaac(orgCode);
    }
  }, [props.iaac, getOrganizationIaac, orgCode]);

  useEffect(() => {
    getOrganizationIaacLicenses(orgCode);
  }, [orgCode, getOrganizationIaacLicenses]);

  useEffect(() => {
    setSelectedSubscription(props.iaac?.subscription || null);
  }, [orgCode, props.iaac?.subscription]);

  // Get organization global iaac information
  useEffect(() => {
    console.log("~~~~~useEffect for getting iaac information");
    if (props.globalIaac === null || props.globalIaac === undefined) {
      getGlobalIaac(orgCode);
    }
  }, [props.globalIaac, getGlobalIaac, orgCode]);

  //For displaying message for getting organization iaac
  let getOrganizationIaacMsg = props.getOrganizationIaacMessage;
  let getOrganizationIaacErr = props.getOrganizationIaacError;
  useEffect(() => {
    console.log("getOrganizationIaacMsg = " + getOrganizationIaacMsg);
    if (getOrganizationIaacMsg || getOrganizationIaacErr) {
      console.log(
        "Inside if, getOrganizationIaacMsg = " + getOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    getOrganizationIaacMsg,
    getOrganizationIaacErr,
    clearAllOrganizationIaacMessages,
  ]);

  const getAndSetCustomSubscriptionState = useCallback(() => {
    if (props.globalIaac !== null && props.globalIaac !== undefined) {
      const { subscriptions } = props.globalIaac;
      // Filter out custom subscriptions
      const customSubscription = subscriptions.filter(
        (sub) => !STANDARD_IAAC_PLANS.includes(sub.subscription)
      );
      console.log(
        "getAndSetCustomSubscriptionState, customSubscription:",
        customSubscription
      );
      if (customSubscription.length > 0) {
        setEditCustomLicenseName(customSubscription[0].subscription);
        setEditCustomPrice(customSubscription[0].price);
        setEditCustomLimit(customSubscription[0].limit);
        setCustomSubscription(customSubscription[0]);
      } else {
        setCustomSubscription(null);
      }
    }
  }, [props.globalIaac]);

  //For displaying message for getting global iaac
  let getGlobalIaacMsg = props.getGlobalIaacMessage;
  let getGlobalIaacErr = props.getGlobalIaacError;
  useEffect(() => {
    // If global iaac is retrieved, store it in state
    if (getGlobalIaacMsg) {
      getAndSetCustomSubscriptionState();
    }
    console.log("getGlobalIaacMsg = " + getGlobalIaacMsg);
    if (getGlobalIaacMsg || getGlobalIaacErr) {
      console.log("Inside if, getGlobalIaacMsg = " + getGlobalIaacMsg);
      setTimeout(() => {
        clearAllGlobalIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    getGlobalIaacMsg,
    getGlobalIaacErr,
    clearAllGlobalIaacMessages,
    getAndSetCustomSubscriptionState,
  ]);

  const showCreateCustomOrganizationIaac = () => {
    setActiveTab("createCustom");
    document.getElementById("createCustomOrgIaacId").style.display = "block";
    document.getElementById("editCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "none";
  };

  const showEditCustomOrganizationIaac = () => {
    setActiveTab("editCustom");
    document.getElementById("editCustomOrgIaacId").style.display = "block";
    document.getElementById("createCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "none";
  };

  const showOrganizationIaac = () => {
    setActiveTab("plans");
    document.getElementById("editCustomOrgIaacId").style.display = "none";
    document.getElementById("createCustomOrgIaacId").style.display = "none";
    document.getElementById("organizationIaacId").style.display = "block";
  };

  const getTabButtonSx = (tabKey, isDisabled = false) => {
    const isActive = activeTab === tabKey;
    return {
      color: isDisabled ? "#9ca3af" : isActive ? "#193a6f" : "#4264a0",
      padding: "0.5rem 1rem",
      textTransform: "none",
      fontWeight: isActive ? 700 : 500,
      borderRadius: "6px",
      backgroundColor: isActive ? "#e8eef8" : "transparent",
      borderBottom: isActive ? "2px solid #193a6f" : "2px solid transparent",
      "&:hover": {
        backgroundColor: isDisabled ? "transparent" : "#eef3fa",
      },
    };
  };

  const isCustomLicensePresent = () => {
    if (props.globalIaac !== null && props.globalIaac !== undefined) {
      const { subscriptions } = props.globalIaac;
      const customSubscription = subscriptions.some(
        (sub) => !STANDARD_IAAC_PLANS.includes(sub.subscription)
      );
      // console.log("In isCustomLicensePresent, customSubscription : ", customSubscription)
      return customSubscription;
    }
    return false;
  };

  const handleCreateOrganizationIaac = () => {
    const iaacRequest = {
      name: customLicenseName,
      price: customPrice,
      limit: customLimit,
    };
    console.log("handleCreateOrganizationIaac, iaacRequest: ", iaacRequest);
    props.postOrganizationIaac(orgCode, iaacRequest);
  };

  //For displaying message for creating organization iaac
  let postOrganizationIaacMsg = props.createOrganizationIaacMessage;
  let postOrganizationIaacErr = props.createOrganizationIaacError;
  useEffect(() => {
    console.log("postOrganizationIaacMsg = " + postOrganizationIaacMsg);
    if (postOrganizationIaacMsg) {
      getGlobalIaac(orgCode);
    }
    if (postOrganizationIaacMsg || postOrganizationIaacErr) {
      console.log(
        "Inside if, postOrganizationIaacMsg = " + postOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    postOrganizationIaacMsg,
    postOrganizationIaacErr,
    getGlobalIaac,
    orgCode,
    clearAllOrganizationIaacMessages,
  ]);

  const handleSubmitIaacSubscription = () => {
    const licenses = props.iaacLicenses?.subscriptions || [];
    const selected = licenses.find(
      (sub) => sub.subscription === selectedSubscription
    );
    if (!selected) {
      return;
    }
    const iaacRequest = {
      subscription: selected.subscription,
      limit_value: String(selected.limit),
      price: String(selected.price),
    };
    props.putOrganizationIaac(orgCode, iaacRequest, true);
  };

  const handleUpdateCustomOrganizationIaac = () => {
    const orgIaacRequest = {
      subscription: editCustomLicenseName,
      limit_value: editCustomLimit,
      price: editCustomPrice,
    };
    console.log(
      "Submitting for update custom license, orgIaacRequest = ",
      orgIaacRequest
    );
    props.putOrganizationIaac(orgCode, orgIaacRequest, false);
  };

  const handleDeleteOrgIaacSubscription = () => {
    console.log("handleDeleteOrgIaacSubscription: ");
    props.deleteOrganizationIaac(orgCode);
  };

  //For displaying message for updating organization iaac
  let putOrganizationIaacMsg = props.updateOrganizationIaacMessage;
  let putOrganizationIaacErr = props.updateOrganizationIaacError;
  useEffect(() => {
    console.log("putOrganizationIaacMsg = " + putOrganizationIaacMsg);
    if (putOrganizationIaacMsg) {
      getGlobalIaac(orgCode);
      getOrganizationIaac(orgCode);
    }
    if (putOrganizationIaacMsg || putOrganizationIaacErr) {
      console.log(
        "Inside if, putOrganizationIaacMsg = " + putOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 2000);
    }
  }, [
    putOrganizationIaacMsg,
    putOrganizationIaacErr,
    getGlobalIaac,
    getOrganizationIaac,
    clearAllOrganizationIaacMessages,
    orgCode,
  ]);

  //For displaying message for deleting organization iaac
  let delOrganizationIaacMsg = props.deleteOrganizationIaacMessage;
  let delOrganizationIaacErr = props.deleteOrganizationIaacError;
  useEffect(() => {
    console.log("delOrganizationIaacMsg = " + delOrganizationIaacMsg);
    if (delOrganizationIaacMsg) {
      getOrganizationIaac(orgCode);
    }
    if (delOrganizationIaacMsg || delOrganizationIaacErr) {
      // setOrgIaacSubscription(null);
      console.log(
        "Inside if, delOrganizationIaacMsg = " + delOrganizationIaacMsg
      );
      setTimeout(() => {
        clearAllOrganizationIaacMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    delOrganizationIaacMsg,
    delOrganizationIaacErr,
    clearAllOrganizationIaacMessages,
    getOrganizationIaac,
    orgCode,
  ]);

  // let customOrgIaacSubscription = null;
  // if (props.globalIaac !== null && props.globalIaac !== undefined) {
  //   const { subscriptions } = props.globalIaac;
  //   // Filter out custom subscriptions
  //   const customOrgIaacSubscription = subscriptions.filter(sub => !["Basic", "Standard", "Premium"].includes(sub.subscription))[0];
  //   console.log("customOrgIaacSubscription:", customOrgIaacSubscription)
  // }

  return (
    <div>
      <AppBar position="static" style={appBarStyles}>
        <Toolbar>
          <Breadcrumbs aria-label="breadcrumb" sx={{ flexGrow: 1 }}>
            <Link component={RouterLink} to="/organization" color="inherit">
              <HomeOutlinedIcon />
            </Link>
            <Typography color="textPrimary">
              <Link component={RouterLink} to="/organization" color="inherit">
                Organization{" "}
              </Link>
              /
              <Link
                component={RouterLink}
                to="#"
                color="inherit"
                onClick={showOrganizationIaac}
              >
                {" "}
                IaaC{" "}
              </Link>
              {/* <span id="viewId">IaaC</span> */}
            </Typography>
            {props?.organization?.orgname && (
              <Chip label={props?.organization?.orgname} color="primary" />
            )}
          </Breadcrumbs>
          <div>
            <Tooltip
              arrow
              title={
                isCustomLicensePresent()
                  ? "A custom license already exists for this organization. Use Edit Custom License to modify it."
                  : "Create a custom IaaC license for this organization."
              }
            >
              <span>
                <Button
                  onClick={showCreateCustomOrganizationIaac}
                  sx={getTabButtonSx("createCustom", isCustomLicensePresent())}
                  disabled={isCustomLicensePresent()}
                >
                  Create Custom License
                </Button>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                isCustomLicensePresent()
                  ? "Edit the existing custom IaaC license for this organization."
                  : "No custom license exists yet. Create a custom license first."
              }
            >
              <span>
                <Button
                  onClick={showEditCustomOrganizationIaac}
                  sx={getTabButtonSx("editCustom", !isCustomLicensePresent())}
                  disabled={!isCustomLicensePresent()}
                >
                  Edit Custom License
                </Button>
              </span>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>

      <div id="organizationIaacId">
        {(props.isGettingOrgAccounts ||
          (props.isGettingOrganizationIaac && !props.iaac) ||
          (props.isGettingOrganizationIaacLicenses && !props.iaacLicenses) ||
          (props.isGettingGlobalIaac && !props.globalIaac) ||
          props.isDeletingOrganizationIaac) && (
          <div
            style={{
              display: "flex",
              direction: "column",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
              height: "100vh",
            }}
          >
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "24px 16px 40px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 1.5,
              mb: 0.5,
            }}
          >
            <h1 style={{ margin: 0 }}>License Plans</h1>
            {props.iaac?.subscription && (
              <Chip
                label={`Current: ${props.iaac.subscription}`}
                variant="outlined"
                color="primary"
                sx={{ fontWeight: 600 }}
              />
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{ color: "#6b7280", mb: 2, textAlign: "center" }}
          >
            Review available IaaC plans for this organization.
          </Typography>
          {props.getOrganizationIaacLicensesError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while getting license plans.
              {JSON.stringify(props.getOrganizationIaacLicensesError)}
            </Alert>
          )}
          {props.deleteOrganizationIaacMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.deleteOrganizationIaacMessage}
            </Alert>
          )}
          {props.deleteOrganizationIaacError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while deleting organization IaaC.
              {JSON.stringify(props.deleteOrganizationIaacError)}
            </Alert>
          )}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(5, 1fr)",
              },
              gap: 2,
              width: "100%",
              maxWidth: "1200px",
              mt: 1,
            }}
          >
            {orderSubscriptions(props.iaacLicenses?.subscriptions).map((plan) => {
              const isActive = props.iaac?.subscription === plan.subscription;
              const isSelected = selectedSubscription === plan.subscription;

              return (
                <Paper
                  key={plan.subscription}
                  elevation={0}
                  role="button"
                  tabIndex={0}
                  onClick={() => setSelectedSubscription(plan.subscription)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setSelectedSubscription(plan.subscription);
                    }
                  }}
                  sx={{
                    p: 2.5,
                    minHeight: 180,
                    cursor: "pointer",
                    borderRadius: "8px",
                    border: isSelected
                      ? "2px solid #193a6f"
                      : "1px solid #e5eaf2",
                    backgroundColor: isActive ? "#eef3fa" : "#fff",
                    boxShadow: isSelected
                      ? "0 2px 8px rgba(25, 58, 111, 0.16)"
                      : "0 1px 4px rgba(25, 58, 111, 0.06)",
                    outline: "none",
                    "&:hover": {
                      borderColor: "#193a6f",
                    },
                  }}
                >
                  <Stack spacing={1.25}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 1,
                        minHeight: 32,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: "#111827", lineHeight: 1.3 }}
                      >
                        {plan.subscription}
                      </Typography>
                      {isActive && (
                        <Chip
                          size="small"
                          icon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
                          label="Active"
                          color="primary"
                          sx={{ height: 24, fontWeight: 600 }}
                        />
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        mt: 1,
                      }}
                    >
                      <CheckCircleIcon
                        fontSize="small"
                        sx={{ color: isActive || isSelected ? "#193a6f" : "#16a34a" }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          letterSpacing: 0.6,
                          fontWeight: 600,
                          color: isActive || isSelected ? "#193a6f" : "#16a34a",
                        }}
                      >
                        UPLOAD LIMIT
                      </Typography>
                    </Box>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 700, color: "#111827" }}
                    >
                      {plan.limit === -1 ? "Unlimited" : plan.limit}
                    </Typography>
                  </Stack>
                </Paper>
              );
            })}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 3,
              gap: 1.5,
              width: "100%",
              maxWidth: "480px",
              mx: "auto",
            }}
          >
            <Button
              variant="contained"
              disabled={
                !selectedSubscription ||
                selectedSubscription === props.iaac?.subscription ||
                props.isUpdatingOrganizationIaac
              }
              onClick={handleSubmitIaacSubscription}
            >
              Submit
            </Button>
            {props.updateOrganizationIaacMessage && (
              <Alert className="mb-0" color="success" style={{ width: "100%" }}>
                License updated successfully.
              </Alert>
            )}
            {props.updateOrganizationIaacError && (
              <Alert className="mb-0" color="danger" style={{ width: "100%" }}>
                Error while updating organization IaaC.
                {JSON.stringify(props.updateOrganizationIaacError)}
              </Alert>
            )}
          </Box>
        </div>
      </div>

      {/* Create Custom Iaac */}
      <div id="createCustomOrgIaacId" style={{ display: "none" }}>
        <Box
          sx={{
            mt: 2,
            mx: "auto",
            px: { xs: 2, md: 3 },
            width: "100%",
            maxWidth: "640px",
            boxSizing: "border-box",
          }}
        >
          {props.createOrganizationIaacMessage && (
            <Alert className="mt-3 mb-2" color="success">
              {props.createOrganizationIaacMessage}
            </Alert>
          )}
          {props.createOrganizationIaacError && (
            <Alert className="mt-3 mb-2" color="danger">
              Error while creating custom subscription.
              {JSON.stringify(props.createOrganizationIaacError)}
            </Alert>
          )}
          <Card
            elevation={0}
            sx={{
              border: "1px solid #e5eaf2",
              boxShadow: "0 2px 10px rgba(25, 58, 111, 0.06)",
            }}
          >
            <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
              <Typography
                variant="h6"
                align="center"
                sx={{ color: "#193a6f", fontWeight: 600, mb: 0.5 }}
              >
                Create Custom Organization IaaC
              </Typography>
              <Typography
                variant="body2"
                align="center"
                sx={{ color: "#6b7280", mb: 2 }}
              >
                Define a custom license name, monthly price, and upload limit.
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <Stack spacing={2.5}>
                <TextField
                  label="Custom License Name"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={customLicenseName}
                  onChange={(e) => setCustomLicenseName(e.target.value)}
                />
                <TextField
                  label="Price"
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={customPrice}
                  onChange={(e) => setCustomPrice(parseInt(e.target.value))}
                />
                <TextField
                  label="Limit"
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={customLimit}
                  onChange={(e) => setCustomLimit(parseInt(e.target.value))}
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={props.isCreatingOrganizationIaac}
                    onClick={handleCreateOrganizationIaac}
                  >
                    Create
                  </Button>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </div>

      {/* Edit Custom Iaac */}
      <div id="editCustomOrgIaacId" style={{ display: "none" }}>
        <Box
          sx={{
            mt: 2,
            mx: "auto",
            px: { xs: 2, md: 3 },
            width: "100%",
            maxWidth: "640px",
            boxSizing: "border-box",
          }}
        >
          {props.updateOrganizationIaacMessage && (
            <Alert className="mt-3 mb-2" color="success">
              {props.updateOrganizationIaacMessage}
            </Alert>
          )}
          {props.updateOrganizationIaacError && (
            <Alert className="mt-3 mb-2" color="danger">
              Error while updating organization IaaC.
              {JSON.stringify(props.updateOrganizationIaacError)}
            </Alert>
          )}
          <Card
            elevation={0}
            sx={{
              border: "1px solid #e5eaf2",
              boxShadow: "0 2px 10px rgba(25, 58, 111, 0.06)",
            }}
          >
            <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
              <Typography
                variant="h6"
                align="center"
                sx={{ color: "#193a6f", fontWeight: 600, mb: 0.5 }}
              >
                Edit Custom Organization IaaC
              </Typography>
              <Typography
                variant="body2"
                align="center"
                sx={{ color: "#6b7280", mb: 2 }}
              >
                Update price and upload limit for the existing custom license.
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <Stack spacing={2.5}>
                <TextField
                  label="Custom License Name"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={editCustomLicenseName}
                  disabled={true}
                />
                <TextField
                  label="Price"
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={editCustomPrice}
                  onChange={(e) =>
                    setEditCustomPrice(parseInt(e.target.value))
                  }
                />
                <TextField
                  label="Limit"
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={editCustomLimit}
                  onChange={(e) =>
                    setEditCustomLimit(parseInt(e.target.value))
                  }
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={props.isUpdatingOrganizationIaac}
                    onClick={handleUpdateCustomOrganizationIaac}
                  >
                    Update
                  </Button>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,
  } = state.orgAccount;

  const {
    iaac,
    iaacLicenses,
    isGettingOrganizationIaacLicenses,
    getOrganizationIaacLicensesError,

    isGettingOrganizationIaac,
    getOrganizationIaacMessage,
    getOrganizationIaacError,

    isCreatingOrganizationIaac,
    createOrganizationIaacMessage,
    createOrganizationIaacError,

    isUpdatingOrganizationIaac,
    updateOrganizationIaacMessage,
    updateOrganizationIaacError,

    isDeletingOrganizationIaac,
    deleteOrganizationIaacMessage,
    deleteOrganizationIaacError,
  } = state.organizationIaac;

  const {
    iaac: globalIaac,
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
  } = state.globalIaac;

  return {
    organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,

    iaac,
    iaacLicenses,
    isGettingOrganizationIaacLicenses,
    getOrganizationIaacLicensesError,

    isGettingOrganizationIaac,
    getOrganizationIaacMessage,
    getOrganizationIaacError,

    isCreatingOrganizationIaac,
    createOrganizationIaacMessage,
    createOrganizationIaacError,

    isUpdatingOrganizationIaac,
    updateOrganizationIaacMessage,
    updateOrganizationIaacError,

    isDeletingOrganizationIaac,
    deleteOrganizationIaacMessage,
    deleteOrganizationIaacError,

    globalIaac,
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrgAccounts: (orgCode) => {
      dispatch(getOrgAccounts(orgCode));
    },
    clearAllOrgAcctMessages: () => {
      dispatch(clearAllOrgAcctMessages());
    },
    getOrganizationIaac: (orgCode) => {
      // console.log("before dispatch getOrganizationIaac")
      dispatch(getOrganizationIaac(orgCode));
    },
    getOrganizationIaacLicenses: (orgCode) => {
      dispatch(getOrganizationIaacLicenses(orgCode));
    },
    postOrganizationIaac: (orgCode, iaacRequest) => {
      dispatch(postOrganizationIaac(orgCode, iaacRequest));
    },
    putOrganizationIaac: (orgCode, iaacRequest, subscriptionChange) => {
      dispatch(putOrganizationIaac(orgCode, iaacRequest, subscriptionChange));
    },
    deleteOrganizationIaac: (orgCode, iaacRequest) => {
      dispatch(deleteOrganizationIaac(orgCode, iaacRequest));
    },
    clearAllOrganizationIaacMessages: () => {
      dispatch(clearAllOrganizationIaacMessages());
    },
    getGlobalIaac: (orgCode) => {
      dispatch(getGlobalIaac(orgCode));
    },
    clearAllGlobalIaacMessages: () => {
      dispatch(clearAllGlobalIaacMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationIaac);
